//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tableGrid from '../tableGrid'
import cellGrid from '../cellGrid'
import layer from './layer.vue'
import { FactoryUtils } from "../../utils/FactoryUtils"
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              cell:[],
              tabledata:{},
              planBScroll:null,
            }
        },
        components: {
          tableGrid,
          cellGrid,
          layer
        },
        created(){
            FactoryUtils.atPlanDetail().then(data =>{
                this.title = data.title
                this.tabledata = data.tabledata
            })
        },
        mounted(){
           
        },
        methods:{
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
          },
          close(){
            this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
